/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

export enum TSCockpitType {
    STATUS = <any>'STATUS',
    ANZAHL_GESUCHE = <any>'ANZAHL_GESUCHE',
    NEUE_GESUCHE = <any>'NEUE_GESUCHE',
    GESUCHE_KANTON = <any>'GESUCHE_KANTON',
    GESUCHE_ERFASSUNGSART = <any>'GESUCHE_ERFASSUNGSART',
    SCHADENART = <any>'SCHADENART',
    GESCHAETZTE_KOSTEN = <any>'GESCHAETZTE_KOSTEN',
}

export function getTSCockpitSelectValues(): Array<TSCockpitType> {
    return [
        TSCockpitType.STATUS,
        TSCockpitType.ANZAHL_GESUCHE,
        TSCockpitType.NEUE_GESUCHE,
        TSCockpitType.GESUCHE_KANTON,
        TSCockpitType.GESUCHE_ERFASSUNGSART,
        TSCockpitType.SCHADENART,
        TSCockpitType.GESCHAETZTE_KOSTEN,
    ];
}

export function cockpitSelectPrefix(): string {
    return 'TSCockpitSelect_';
}






// WEBPACK FOOTER //
// ./src/app/models/enums/TSCockpitType.ts